import { Component, inject } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { MatrizEventosService } from '../../../services/operative/matriz-eventos/matriz-eventos.service';
import { DataService } from '../../../services/data/data.service';
import { TranslateService } from '@ngx-translate/core';

import { FormGroup, FormControl, Validators, ValidatorFn } from '@angular/forms';
import { FuncionesMes, periodosOperativo } from '../../funciones/funcionesGenerales';
import { event } from '../../funciones/estructuras';
//Se eliminara al implementar los catalogos por administrador
import { companies, PERMISOS } from './../../../shared/catalogos';

import Swal from 'sweetalert2';
import moment from 'moment';
import * as XLSX from 'xlsx'
import { ExcelService } from '../../../services/excel/excel.service';
import { firstValueFrom, forkJoin } from 'rxjs';
import { messages } from '../../funciones/mensajes';

@Component({
  selector: 'app-matriz-eventos',
  templateUrl: './matriz-eventos.component.html',
  styleUrl: './matriz-eventos.component.css'
})
export class MatrizEventosComponent {
  public readonly permisos = PERMISOS;

  private idInstitucion = '666c883f3f6f9a0012b3e263';
  private errorMessage = '<br/><br/><div> <span style="text-aling: center;font-size: 10pt;font-weight: 200;">Precione</span>'+
  '<span style="text-aling: center;font-size: 10pt;font-weight: 600;"> esc </span>'+
  '<span style="text-aling: center;font-size: 10pt;font-weight: 200;">para cerrar</span></div>';


  translate = inject(TranslateService);

  accion = [];
  agencia = [];
  control = [];
  estatus = [];
  fuente = [];
  impacto = [];
  perdida = [];
  probabilidad = [];
  riesgo = [];
  area = [];
  categorias = [];
  conceptos = [];
  eventos = [];
  estatusevent = [];
  nivelExp = 0;

  progressInfo = [];
  selectedFiles;

  ordenado = 'norm';
  dataOrdenado = [];
  private dataOrdenadoAll = [];
  niveles = 3;

  existSelec = false;
  seleccionados = 0;

  agr = false;
  edi = false;

  private probabilidadVal = [];
  private impactoVal = [];
  private controlVal = [];
  private nivelRiesgo = [];
  private nivelExpocision = [];

  validado = ['Validado','Sin validar'];
  itemEdicion;

  step = 0;
  ingresoMontos = true;

  prefix = '';
  suffix = '';
  miles = ',';
  decimal = '.';
  precicion = 0;
  aling = '';

  Periodos = [];
  Periodos2 = [];
  cadenaEvaluacion = [];
  cadenaEvaluacion2 = [];
  filtroPeriodos = false;

  subTitles = '';
  subTitles2 = '';

  formEvento = new FormGroup({
    area: new FormControl('default', [Validators.required, this.defaultValidation('area')]),
    categoria: new FormControl('default', [Validators.required, this.defaultValidation('categoria')]),
    evento: new FormControl('default', [Validators.required, this.defaultValidation('evento')]),
    fecha: new FormControl('', [Validators.required]),
    accion: new FormControl('default', [Validators.required, this.defaultValidation('accion')]),
    riesgo: new FormControl('default', [Validators.required, this.defaultValidation('riesgo')]),
    monto: new FormControl(''),
    impacto: new FormControl('default', [Validators.required, this.defaultValidation('impacto')]),
    control: new FormControl('default', [Validators.required, this.defaultValidation('control')]),
    riesgoImp: new FormControl({value: '', disabled: true}),
    porACont: new FormControl({value: '', disabled: true}),
    agencia: new FormControl('default'),
    concepto: new FormControl('default'),
    nivel4: new FormControl('default'),
    detalle: new FormControl('', [Validators.required, this.defaultValidation('detalle')]),
    fuente: new FormControl('default', [Validators.required, this.defaultValidation('fuente')]),
    perdida: new FormControl('default', [Validators.required, this.defaultValidation('perdida')]),
    perdidaTras: new FormControl('', [Validators.required, this.defaultValidation('perdidaTras')]),
    probabilidad: new FormControl('default', [Validators.required, this.defaultValidation('probabilidad')]),
    riesgoImp2: new FormControl({value: '', disabled: true}),
    porControl: new FormControl({value: '', disabled: true}),
    nivelExp: new FormControl({value: '', disabled: true}),
    recomRies: new FormControl(''),
    plan: new FormControl(''),
    fechaDead: new FormControl(''),
    quienReg: new FormControl({value: '', disabled: true}),
    estatusPlan: new FormControl('default'),
    estatusEvent: new FormControl(''),
  },{ validators: this.montoCorrectoValidacion() });
  
  formSelects = new FormGroup({
    area: new FormControl('default'),
    categoria: new FormControl('default'),
    agencia: new FormControl('default'),
  });
  private defaultValues = {
    area: 'default',
    categoria: 'default',
    evento: 'default',
    fecha: '',
    accion: 'default',
    riesgo: 'default',
    monto: '',
    impacto: 'default',
    control: 'default',
    riesgoImp: '',
    porACont: '',
    agencia: 'default',
    concepto: 'default',
    nivel4: 'default',
    detalle: '',
    fuente: 'default',
    perdida: 'default',
    perdidaTras: '',
    probabilidad: 'default',
    riesgoImp2: '',
    porControl: '',
    nivelExp: '',
    recomRies: '',
    plan: '',
    fechaDead: '',
    quienReg: '',
    estatusPlan: 'default',
    estatusEvent: ''
  }

  private cookies = inject( CookieService)

  constructor(
    private services: MatrizEventosService,
    public dataService: DataService,
    private exportExcel: ExcelService,
  ){
    this.idInstitucion = this.cookies.get('idInstitucion');
    const ex = companies.find(i => i.id === this.idInstitucion);
    this.suffix = ex.suffix;
    this.startCatalogs();
  }

  public setStep(index: number) { this.step = index; }
  public nextStep() { this.step++; }
  public prevStep() { this.step--; }

  private async startCatalogs(){
    const catalogos = [
      'area',
      'categoria',
      'accion',
      'riesgo',
      'agencia',
      'efectividadcontrol',
      'estatus',
      'fuente',
      'impacto',
      'perdida',
      'probabilidad',
      'estatusevento',
      'controlval',
      'nivelriesgo',
      'nivelexpocision',
    ] as const;

    const data = await firstValueFrom(
      forkJoin(
        Object.fromEntries(
          catalogos.map(tipo => [
            tipo,
            this.services.getCatalogos(this.idInstitucion, tipo),
          ]),
        ),
      ),
    );
    this.area = [].concat(data['area']);
    this.categorias = [].concat(data['categoria']);
    this.accion = [].concat(data['accion']);
    this.agencia = [].concat(data['agencia']);
    this.control = [].concat(data['efectividadcontrol']);
    this.estatus = [].concat(data['estatus']);
    this.fuente = [].concat(data['fuente']);
    this.impacto = [].concat(data['impacto']);
    this.perdida = [].concat(data['perdida']);
    this.probabilidad = [].concat(data['probabilidad']);
    this.riesgo = [].concat(data['riesgo']);
    this.conceptos = [];
    this.eventos = [];
    this.estatusevent = [].concat(data['estatusevento']);
    this.impactoVal = [].concat(data['impacto']);
    this.probabilidadVal = [].concat(data['probabilidad']);
    this.controlVal = [].concat(data['controlval']);
    this.nivelRiesgo = [].concat(data['nivelriesgo']);
    this.nivelExpocision = [].concat(data['nivelexpocision']);
    this.getData();
  }
  private async getData(){
    try{
      this.dataOrdenado = [];
      var response = await firstValueFrom(
        this.services.getEventos()
      );
    } catch (error) {
      messages.errorMessageGraph(error.error)
    }
    const data = response['data'];
    for(const event of data){
      if(event.institution_id === this.idInstitucion){
        this.dataOrdenado.push({
          id: event.id,
          area: event.area,
          branch_office: event.branch_office,
          category: event.category,
          concept: event.concept,
          event: event.event,
          event_date: moment(event.event_date.split('T')[0]).format("YYYY-MM-DD"),
          detail: event.detail,
          action_taken: event.action_taken,
          source: event.source,
          derived_risk: event.derived_risk,
          loss: event.loss,
          loss_amount: event.loss_amount,
          transferred_loss: event.transferred_loss,
          net_loss: event.net_loss,
          impact: event.impact,
          probability: event.probability,
          control: event.control,
          x: event.x,
          y: event.y,
          implicit_risk: event.implicit_risk,
          implicit_risk_level: event.implicit_risk_level,
          control_2: event.control_2,
          to_control: event.to_control,
          exposure_level: event.exposure_level,
          recommendation: event.recommendation,
          work_plan: event.work_plan,
          deadline: event.deadline!==undefined ? moment(event.deadline.split('T')[0]).format("YYYY-MM-DD") : undefined,
          plan_status: event.plan_status,
          event_status: event.event_status,
          register: event.register,
          institution_id: event.institution_id,
        });
      }
    }
    this.dataOrdenadoAll = JSON.parse(JSON.stringify(this.dataOrdenado));
    this.obtPeriodos();
  }
  /* Funcionalidad fechas */
  public escrituraPeriodo(Periodo){
    if(Periodo.split(' ').length === 2){
      const datos = Periodo.split(' ');
      return this.translate.instant('filtros.'+datos[0])+' '+datos[1];
    }else if(Periodo.split(' ').length === 5){
      const datos = Periodo.split(' ');
      return this.translate.instant('filtros.'+datos[0])+' '+datos[1]+' '+datos[2]+' '+this.translate.instant('filtros.'+datos[0])+' '+datos[1];
    }
    return Periodo;
  }
  private obtPeriodos(){
    const iniDate = this.dataOrdenadoAll.map( i => moment(i.event_date) ).sort( (a, b) => a.diff(b))[0];
    
    const fecha = moment();
    this.Periodos = periodosOperativo.obtenerPeriodosFechas(fecha, iniDate);
    this.Periodos[this.Periodos.length-1].series[this.Periodos[this.Periodos.length-1].series.length-1].check = false;
    this.Periodos[0].series[0].check = true;
    this.Periodos2 = periodosOperativo.obtenerPeriodosFechas(fecha, iniDate);
    this.obtenerDataEvaluacion();
  }
  public cambioPeriodo(per, rango){
    if(rango == 'inicio'){
      for(const an of this.Periodos){
        for(const mes of an.series){
          if(mes.periodo === per.periodo){
            mes.check = true;
          }else{
            mes.check = false;
          }
        }
      }
      var check = false, contador = 0, selec2 = 0, posAn = 0, posMes = 0;
      for(let i = 0; i < this.Periodos.length; i++){
        for(let j = 0; j < this.Periodos[i].series.length; j++){
          if(this.Periodos[i].series[j].check || check){
            this.Periodos2[i].series[j].visible = true;
            if(!check){
              posAn = i;
              posMes = j;
            }
            check = true;
          }else{
            this.Periodos2[i].series[j].visible = false;
            this.Periodos2[i].series[j].check = false;
          }
          if(this.Periodos2[i].series[j].visible){
            contador++;
          }
          if(this.Periodos2[i].series[j].check){
            selec2++;
          }
        }
        if(contador == 0){
          this.Periodos2[i].visible = false;
        }else{
          this.Periodos2[i].visible = true;
        }
      }
      if(selec2 === 0){
        this.Periodos2[posAn].series[posMes].check = true;
      }
    }
    if(rango == 'fin'){
      for(const an of this.Periodos2){
        for(const mes of an.series){
          if(mes.periodo === per.periodo){
            mes.check = true;
          }else{
            mes.check = false;
          }
        }
      }
    }
    
    this.obtenerDataEvaluacion();
  }
  /* Obtención de periodos */
  private obtenerDataEvaluacion(){
    this.cadenaEvaluacion = [];
    this.cadenaEvaluacion2 = [];
    this.subTitles = "";
    this.subTitles2 = "";
    var tot=0;
    for(var i = this.Periodos.length-1; i>=0; i--){
      for(var j = this.Periodos[i].series.length-1; j>=0; j--){
        if(this.Periodos[i].series[j].check){
          this.cadenaEvaluacion.push({
            evaluacion: this.Periodos[i].series[j].periodo,
            porcentaje: '%',
            periodo: this.Periodos[i].series[j].an + '-' + FuncionesMes.f_switchmes3(this.Periodos[i].series[j].mes)
          });
          tot++;
        }
      }
    }
    for(var i = this.Periodos2.length-1; i>=0; i--){
      for(var j = this.Periodos2[i].series.length-1; j>=0; j--){
        if(this.Periodos2[i].series[j].check){
          this.cadenaEvaluacion2.push({
            evaluacion: this.Periodos2[i].series[j].periodo,
            porcentaje: '%',
            periodo: this.Periodos2[i].series[j].an + '-' + FuncionesMes.f_switchmes3(this.Periodos2[i].series[j].mes)
          });
          tot++;
        }
      }
    }
    this.subTitles = this.cadenaEvaluacion[0].evaluacion;
    this.subTitles2 = this.cadenaEvaluacion2[0].evaluacion;
    var check = false, contador = 0;
    for(let i = 0; i < this.Periodos.length; i++){
      for(let j = 0; j < this.Periodos[i].series.length; j++){
        if(this.Periodos[i].series[j].check || check){
          this.Periodos2[i].series[j].visible = true;
          check = true;
        }else{
          this.Periodos2[i].series[j].visible = false;
        }
        if(this.Periodos2[i].series[j].visible){
          contador++;
        }
      }
      if(contador == 0){
        this.Periodos2[i].visible = false;
      }
    }
    this.selecCategoriaFilter();
  }
  /* */
  public icono(){
    switch(this.ordenado){
      case 'norm':
        return 'file_upload';
      case 'asc':
        return 'file_upload';
      case 'des':
        return 'download';
      default:
        return 'file_upload';
    }
  }
  public ordenar(prop){
    if(this.ordenado === 'norm'){
      this.ordenado = 'asc';
    }else if(this.ordenado === 'asc'){
      this.ordenado = 'des';
    }else if(this.ordenado === 'des'){
      this.ordenado = 'norm';
    }
    this.orden(prop);
  }
  public orden(prop){
    if(this.ordenado === 'asc'){
      this.dataOrdenado.sort(function (a, b) {
        if ( moment(a[''+prop]).isAfter(moment(b[''+prop])) ) {
          return 1;
        }
        if ( moment(a[''+prop]).isBefore(moment(b[''+prop])) ) {
          return -1;
        }
        return 0;
      });
    }else if(this.ordenado === 'des'){
      this.dataOrdenado.sort(function (a, b) {
        if ( moment(a[''+prop]).isBefore(moment(b[''+prop])) ) {
          return 1;
        }
        if ( moment(a[''+prop]).isAfter(moment(b[''+prop])) ) {
          return -1;
        }
        return 0;
      });
    }
  }
  //Se puede guardar o no información
  public puedeGuardar(){
    if( this.formEvento.valid && !this.montoCorrecto() ){
      return ''
    }
    return 'w3-disabled'
  }
  public guardarInfo(estatus){
    if(this.edi){
      this.guardarEditarDato(estatus);
    }else if(this.agr){
      this.guardarDato(estatus);
    }
  }
  public escritura(columna, item){
    switch(columna){
      case 'area':
        return this.area.filter( ar =>  ar.id===Number(item.area) )[0].name;
      case 'agencia':
        return this.agencia.filter( ar =>  ar.id===Number(item.branch_office) )[0].name;
      case 'categoria':
        return this.categorias.filter( ar =>  ar.id===Number(item.category) )[0].name;
      case 'evento':
        const con = this.categorias.filter( ar =>  ar.id===Number(item.category) )[0].values;
        const even = con.filter( ar =>  ar.id===Number(item.concept) )[0].values;
        return even.filter( ar =>  ar.id===Number(item.event) )[0].name;
      case 'fecha':
        return moment(item.event_date).format("DD-MM-YYYY");
      case 'estatus':
        let estatus = '';
        const estado = this.estatusevent.filter(ev => ev.id === item.event_status)[0];
        if(estado.name === 'Normal'){
          estatus = 'Enviar a validación';
        }else{
          estatus = estado.name;
        }
        return estatus;
    }
  }
  /* Eventos en tabla */
  public seleccion(elem){
    let cont = 0;
    for(const item of this.dataOrdenado){
      if(item.id === elem.id){
        item.select = !item.select;
      }
      if(item.select){
        cont++;
      }
    }
    this.seleccionados = cont;
    if(cont === 0){
      this.existSelec = false;
    }else{
      this.existSelec = true;
    }
  }
  public agregar(){
    this.agr = true;
    document.getElementById('table').style.display = 'none';
    document.getElementById('form').style.display = 'block';

    var fecha = new Date();
    this.formEvento.controls['fecha'].setValue(moment(fecha).format("YYYY-MM-DD"));
    this.formEvento.controls['monto'].setValue('0');
    this.formEvento.controls['perdidaTras'].setValue('0');
    this.formEvento.controls['quienReg'].setValue(this.dataService.user);
  }
  public async agregarArchivo(){
    let guardo = false,introdujo: any;
     introdujo = await Swal.fire({
      title: ''+ this.translate.instant('operative.matriz-eventos.archivo'),
      text: "",
      input: 'file',
      inputAttributes: {
        "accept": ".xlsx",
        "aria-label": "Upload your profile picture"
      },
      showCancelButton: true,
      confirmButtonColor: '#ff6b00',
      cancelButtonColor: '#B9B9BC',
      confirmButtonText: this.translate.instant('swal.acep'),
      cancelButtonText: this.translate.instant('swal.cerr'),
      reverseButtons: true,
      customClass: {
        actions: 'aleema-swal-actions',
        confirmButton: 'aleema-swal-confirm',
        cancelButton: 'aleema-swal-cancel',
        input: 'aleema-swal-select'
      },
      inputValidator: (value) => {
        if (!value) {
          return 'Ingerese un dato valido';
        }
        guardo = true;
        return '';
      }
    });

    if(guardo){
      messages.messageSaving(this.translate.instant('operative.matriz-eventos.guardando'), this.translate.instant('operative.matriz-eventos.espera'));
      this.progressInfo = [];
      this.selectedFiles = introdujo.value;
      var reader = new FileReader();
      reader.readAsDataURL(this.selectedFiles);
      reader.onload = (e) => {
        let data = reader.result;
        this.obtBuffer(data);
      }
    }
  }
  private async obtBuffer(data){
    const file = await fetch(data)
    const buffer = await file.arrayBuffer().then( async (response) => {
      const workbook = XLSX.read(response);
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const raw_data: any = XLSX.utils.sheet_to_json(worksheet, {header: 1});
      let cerro = false;
      for(var i = 0; i < raw_data.length; i++){
        if(raw_data[i].length !== 0 && i !== 0){
          await this.guardarDatoMasivo(raw_data[i]);
        }else if(i !== 0 && i === raw_data.length-1){
          Swal.close();
          messages.succesMessageGraph(this.translate.instant('operative.matriz-eventos.informacion-agregada'));
          cerro = true;
          break;
        }
      }

      if(!cerro){
        Swal.close();
        messages.succesMessageGraph(this.translate.instant('operative.matriz-eventos.informacion-agregada'));
      }
    });
  }
  private numeroAFecha(numeroDeDias, esExcel = true) {
    var diasDesde1900 = esExcel ? 25567 + 1 : 25567;
    const fecha = new Date((numeroDeDias - diasDesde1900) * 86400 * 1000);
    return moment(fecha).format("YYYY-MM-DD");
  }
  public cerrar(){
    this.agr = false;
    this.edi = false;
    this.step = 0;

    document.getElementById('table').style.display = 'block';
    document.getElementById('form').style.display = 'none';

    this.formEvento.reset(this.defaultValues);
  }
  public async editar(){
    this.edi = true;
    let itemm = undefined;
    for(const item of this.dataOrdenadoAll){
      if(item.select){
        itemm = item;
        this.itemEdicion = item;
        this.formEvento.controls['area'].setValue(item.area);
        this.formEvento.controls['categoria'].setValue(item.category);
        this.selecCategoria();
        this.formEvento.controls['concepto'].setValue(item.concept);
        this.selecConcepto();
        this.formEvento.controls['evento'].setValue(item.event);
        this.formEvento.controls['fecha'].setValue(moment(item.event_date).format("YYYY-MM-DD"));
        this.formEvento.controls['accion'].setValue(item.action_taken);
        this.formEvento.controls['riesgo'].setValue(item.derived_risk);
        this.formEvento.controls['monto'].setValue(item.loss_amount);
        this.formEvento.controls['impacto'].setValue(item.impact);
        this.formEvento.controls['control'].setValue(item.control);
        this.formEvento.controls['riesgoImp'].setValue(item.implicit_risk);
        this.formEvento.controls['porACont'].setValue(item.to_control);
        this.formEvento.controls['agencia'].setValue(item.branch_office);
        this.formEvento.controls['detalle'].setValue(item.detail);
        this.formEvento.controls['fuente'].setValue(item.source);
        this.formEvento.controls['perdida'].setValue(item.loss);
        this.formEvento.controls['perdidaTras'].setValue(item.transferred_loss);
        this.formEvento.controls['probabilidad'].setValue(item.probability);
        this.formEvento.controls['riesgoImp2'].setValue(item.implicit_risk_level);
        this.formEvento.controls['porControl'].setValue(item.control_2);
        this.formEvento.controls['nivelExp'].setValue(item.exposure_level);
        this.formEvento.controls['recomRies'].setValue(item.recommendation===null?'':item.recommendation);
        this.formEvento.controls['plan'].setValue(item.work_plan===null?'':item.work_plan);
        this.formEvento.controls['fechaDead'].setValue(item.deadline===null?'':moment(item.deadline).format("YYYY-MM-DD"));
        this.formEvento.controls['quienReg'].setValue(item.register);
        this.formEvento.controls['estatusPlan'].setValue(item.plan_status===null?'default':item.plan_status);
        this.formEvento.controls['estatusEvent'].setValue(item.event_status);
        this.riesgoImp();
        this.controlImp();
        this.ingresoMontosForm();
        this.selecCategoriaFilter();
      }
    }

    if( itemm.event_status === 3 || itemm.event_status === 2 && this.dataService.role === 'Ingresador'){
      const result = await messages.confirmationSave(
        itemm.event_status === 3 ? this.translate.instant('swal.edicionValid') : this.translate.instant('swal.edicionEnValid'),
        this.translate.instant('swal.edicionValidMess'),
        this.translate
      );
      if (result) {
        document.getElementById('table').style.display = 'none';
        document.getElementById('form').style.display = 'block';
      }
    }else if( itemm !== undefined ){
      document.getElementById('table').style.display = 'none';
      document.getElementById('form').style.display = 'block';
    }
    
  }
  public async copiar(){
    messages.messageSaving(this.translate.instant('operative.matriz-eventos.copiando'), this.translate.instant('operative.matriz-eventos.espera'));
    for(const item of this.dataOrdenado){
      if(item.select){
        let report= new event();

        report.area = item.area;
        report.category = item.category;
        report.event = item.event;
        report.event_date = item.event_date;
        report.action_taken = item.action_taken;
        report.derived_risk = item.derived_risk;
        report.loss_amount = item.loss_amount;
        report.impact = item.impact;
        report.control = item.control;
        report.implicit_risk = item.implicit_risk;
        report.to_control = item.to_control;
        report.branch_office = item.branch_office;
        report.concept = item.concept;
        report.detail = item.detail;
        report.source = item.source;
        report.loss = item.loss;
        report.transferred_loss = item.transferred_loss;
        report.probability = item.probability;
        report.implicit_risk_level = item.implicit_risk_level;
        report.control_2 = item.control_2;
        report.exposure_level = item.exposure_level;
        report.recommendation = item.recommendation;
        report.work_plan = item.work_plan;
        report.deadline = item.deadline;
        report.plan_status = item.plan_status;
        report.net_loss = item.net_loss;
        report.x = item.x;
        report.y = item.y;
        report.register = item.register;
        report.institution_id = item.institution_id;
        
        try {
          const response = await firstValueFrom(
            this.services.postEventos(report)
          );
          const event = response['data'];
          this.dataOrdenadoAll.push({
            id: event.id,
            area: event.area,
            branch_office: event.branch_office,
            category: event.category,
            concept: event.concept,
            event: event.event,
            event_date: moment(event.event_date.split('T')[0]).format("YYYY-MM-DD"),
            detail: event.detail,
            action_taken: event.action_taken,
            source: event.source,
            derived_risk: event.derived_risk,
            loss: event.loss,
            loss_amount: event.loss_amount,
            transferred_loss: event.transferred_loss,
            net_loss: event.net_loss,
            impact: event.impact,
            probability: event.probability,
            control: event.control,
            x: event.x,
            y: event.y,
            implicit_risk: event.implicit_risk,
            implicit_risk_level: event.implicit_risk_level,
            control_2: event.control_2,
            to_control: event.to_control,
            exposure_level: event.exposure_level,
            recommendation: event.recommendation,
            work_plan: event.work_plan,
            deadline: event.deadline !== null ? moment(event.deadline.split('T')[0]).format("YYYY-MM-DD") : undefined,
            plan_status: event.plan_status,
            event_status: event.event_status,
            register: event.register,
            institution_id: event.institution_id,
          });
          item.select = false;
          this.selecCategoriaFilter();
          this.existSelec = false;
          Swal.close();
          messages.succesMessageGraph(this.translate.instant('operative.matriz-eventos.informacion-copiada'));
        } catch (error) {
          messages.errorMessageGraph(error.error);
        }      
      }
    }
  }
  public async eliminar(){
    const result = await messages.confirmationSave(
      this.translate.instant('operative.matriz-eventos.desea-eliminar'),
      this.translate.instant(''),
      this.translate
    );
    if(result){
      messages.messageSaving(this.translate.instant('operative.matriz-eventos.eliminando'), this.translate.instant('operative.matriz-eventos.espera'));
      let aux = [];
      for(const ev of this.dataOrdenadoAll){
        const ex = this.dataOrdenado.find(e => e.id === ev.id && e.select);
        if(ex){
          try {
            const response = await firstValueFrom(
              this.services.deleteEventos(ev)
            );
          } catch (error) {
            messages.errorMessageGraph(error.error);
            return;
          }
        }else{
          aux.push(ev);
        }
      }
      Swal.close();
      messages.succesMessageGraph(this.translate.instant('operative.matriz-eventos.informacion-eliminada'));
      this.dataOrdenadoAll = [].concat(aux);
      this.selecCategoriaFilter();
      this.existSelec = false;
    }
  }
  
  /* Agregar info */
  public async guardarDatoMasivo(array){
    let report= new event();

    report.area = array[0];
    report.branch_office = array[1];
    report.category = array[2];
    report.concept = array[3];
    report.event = array[4];
    report.event_date = this.numeroAFecha(array[5]);
    report.detail = array[6];
    report.action_taken = array[7];
    report.source = array[8];
    report.derived_risk = array[9];
    report.loss = array[10];
    report.loss_amount = array[11];
    report.transferred_loss = array[12];
    report.net_loss = array[13];
    report.impact = array[14];
    report.probability = array[15];
    report.control = array[16];
    report.x = array[17];
    report.y = array[18];
    report.implicit_risk = array[19];
    report.implicit_risk_level = array[20];
    report.control_2 = array[21]<=1?array[21]*100:array[21];
    report.to_control = array[22]<=1?array[22]*100:array[22];
    report.exposure_level = array[23];
    
    if(array[24]){
      report.recommendation = array[24];
    }
    if(array[25]){
      report.work_plan = array[25];
    }
    if(array[26]){
      report.deadline = this.numeroAFecha(array[26]);
    }
    if(array[27]){
      report.plan_status = array[27];
    }

    report.register = this.dataService.user;
    report.institution_id = this.idInstitucion;

    try {
      const response = await firstValueFrom(
        this.services.postEventos(report)
      );
      const event = response['data'];
      this.dataOrdenadoAll.push({
        id: event.id,
        area: event.area,
        branch_office: event.branch_office,
        category: event.category,
        concept: event.concept,
        event: event.event,
        event_date: moment(event.event_date.split('T')[0]).format("YYYY-MM-DD"),
        detail: event.detail,
        action_taken: event.action_taken,
        source: event.source,
        derived_risk: event.derived_risk,
        loss: event.loss,
        loss_amount: event.loss_amount,
        transferred_loss: event.transferred_loss,
        net_loss: event.net_loss,
        impact: event.impact,
        probability: event.probability,
        control: event.control,
        x: event.x,
        y: event.y,
        implicit_risk: event.implicit_risk,
        implicit_risk_level: event.implicit_risk_level,
        control_2: event.control_2,
        to_control: event.to_control,
        exposure_level: event.exposure_level,
        recommendation: event.recommendation,
        work_plan: event.work_plan,
        deadline: event.deadline !== undefined ? moment(event.deadline.split('T')[0]).format("YYYY-MM-DD") : undefined,
        plan_status: event.plan_status,
        event_status: event.event_status,
        register: event.register,
        institution_id: event.institution_id,
      });
      this.selecCategoriaFilter();
    } catch (error) {
      messages.errorMessageGraph(error.error);
    }
  }
  public async guardarDato(estatus){
    messages.messageSaving(this.translate.instant('operative.matriz-eventos.guardando'), this.translate.instant('operative.matriz-eventos.espera'));
    let report = new event();

    let imp = this.formEvento.controls['impacto'].value;
    let pro = this.formEvento.controls['probabilidad'].value;

    const im = this.impacto.filter(item => item.id === Number(imp))[0].name;
    const pr = this.probabilidad.filter(item => item.id === Number(pro))[0].name;

    const valIm = this.impactoVal.filter(item => item.name === im)[0].id;
    const valPr = this.probabilidadVal.filter(item => item.name === pr)[0].id;

    report.area = this.formEvento.controls['area'].value;
    report.category = this.formEvento.controls['categoria'].value;
    report.event = this.formEvento.controls['evento'].value;
    report.event_date = moment((this.formEvento.controls['fecha'].value)).format("YYYY-MM-DD");
    report.action_taken = this.formEvento.controls['accion'].value;
    report.derived_risk = this.formEvento.controls['riesgo'].value;
    report.loss_amount = Number(this.formEvento.controls['monto'].value);
    report.impact = this.formEvento.controls['impacto'].value;
    report.control = this.formEvento.controls['control'].value;
    report.implicit_risk = Number(this.formEvento.controls['riesgoImp2'].value);
    report.to_control = Number(this.formEvento.controls['porACont'].value);
    report.branch_office = this.formEvento.controls['agencia'].value;
    report.concept = this.formEvento.controls['concepto'].value;
    report.detail = this.formEvento.controls['detalle'].value;
    report.source = this.formEvento.controls['fuente'].value;
    report.loss = Number(this.formEvento.controls['perdida'].value);
    report.transferred_loss = Number(this.formEvento.controls['perdidaTras'].value);
    report.probability = this.formEvento.controls['probabilidad'].value;
    report.implicit_risk_level = this.formEvento.controls['riesgoImp2'].value;
    report.control_2 = Number(this.formEvento.controls['porControl'].value);
    report.exposure_level = Number(this.nivelExp);
    
    if(this.formEvento.controls['recomRies'].value !== ''){
      report.recommendation = this.formEvento.controls['recomRies'].value;
    }
    if(this.formEvento.controls['plan'].value !== ''){
      report.work_plan = this.formEvento.controls['plan'].value;
    }
    if(this.formEvento.controls['fechaDead'].value !== ''){
      report.deadline = moment((this.formEvento.controls['fechaDead'].value)).format("YYYY-MM-DD");
    }
    if(this.formEvento.controls['estatusPlan'].value !== 'default'){
      report.plan_status = this.formEvento.controls['estatusPlan'].value;
    }
    
    report.net_loss = Number(report.loss_amount)-Number(report.transferred_loss);
    report.x = valIm;
    report.y = valPr;
    report.institution_id = this.idInstitucion;
    report.register = this.dataService.user;

    try {
      const response = await firstValueFrom(
        this.services.postEventos(report)
      );

      const event = response['data'];
      this.dataOrdenadoAll.push({
        id: event.id,
        area: event.area,
        branch_office: event.branch_office,
        category: event.category,
        concept: event.concept,
        event: event.event,
        event_date: moment(event.event_date.split('T')[0]).format("YYYY-MM-DD"),
        detail: event.detail,
        action_taken: event.action_taken,
        source: event.source,
        derived_risk: event.derived_risk,
        loss: event.loss,
        loss_amount: event.loss_amount,
        transferred_loss: event.transferred_loss,
        net_loss: event.net_loss,
        impact: event.impact,
        probability: event.probability,
        control: event.control,
        x: event.x,
        y: event.y,
        implicit_risk: event.implicit_risk,
        implicit_risk_level: event.implicit_risk_level,
        control_2: event.control_2,
        to_control: event.to_control,
        exposure_level: event.exposure_level,
        recommendation: event.recommendation,
        work_plan: event.work_plan,
        deadline: event.deadline !== null ? moment(event.deadline.split('T')[0]).format("YYYY-MM-DD") : undefined,
        plan_status: event.plan_status,
        estatus_event: event.event_status,
        register: event.register,
        institution_id: event.institution_id,
      });
      this.cerrar();
      this.selecCategoriaFilter();
      Swal.close();
      messages.succesMessageGraph(this.translate.instant('operative.matriz-eventos.informacion-agregada'));
    } catch (error) {
      messages.errorMessageGraph(error.error);
      this.cerrar();
    }
  }
  public async guardarEditarDato(estatus){
    messages.messageSaving(this.translate.instant('operative.matriz-eventos.editando'), this.translate.instant('operative.matriz-eventos.espera'));
    for(const item of this.dataOrdenadoAll){
      if(item.select){
        let imp = this.formEvento.controls['impacto'].value;
        let pro = this.formEvento.controls['probabilidad'].value;

        const im = this.impacto.filter(item => item.id === Number(imp))[0].name;
        const pr = this.probabilidad.filter(item => item.id === Number(pro))[0].name;

        const valIm = this.impactoVal.filter(item => item.name === im)[0].value;
        const valPr = this.probabilidadVal.filter(item => item.name === pr)[0].value;

        item.area = Number(this.formEvento.controls['area'].value);
        item.category = Number(this.formEvento.controls['categoria'].value);
        item.event = Number(this.formEvento.controls['evento'].value);
        item.event_date = moment((this.formEvento.controls['fecha'].value)).format("YYYY-MM-DD");
        item.action_taken = Number(this.formEvento.controls['accion'].value);
        item.derived_risk = Number(this.formEvento.controls['riesgo'].value);
        item.loss_amount = Number(this.formEvento.controls['monto'].value);
        item.impact = Number(this.formEvento.controls['impacto'].value);
        item.control = Number(this.formEvento.controls['control'].value);
        item.implicit_risk = Number(this.formEvento.controls['riesgoImp2'].value);
        item.to_control = Number(this.formEvento.controls['porACont'].value);
        item.branch_office = Number(this.formEvento.controls['agencia'].value);
        item.concept = Number(this.formEvento.controls['concepto'].value);
        item.datail = this.formEvento.controls['detalle'].value;
        item.source = Number(this.formEvento.controls['fuente'].value);
        item.loss = Number(this.formEvento.controls['perdida'].value);
        item.transferred_loss = Number(this.formEvento.controls['perdidaTras'].value);
        item.probability = Number(this.formEvento.controls['probabilidad'].value);
        item.implicit_risk_level = Number(this.formEvento.controls['riesgoImp2'].value);
        item.control_2 = Number(this.formEvento.controls['porControl'].value);
        item.exposure_level = Number(this.nivelExp);
        
        if(this.formEvento.controls['recomRies'].value  !== ''){
          item.recommendation = this.formEvento.controls['recomRies'].value;
        }else{
          item.recommendation = null;
        }
        if(this.formEvento.controls['plan'].value  !== ''){
          item.work_plan = this.formEvento.controls['plan'].value;
        }else{
          item.work_plan = null;
        }
        if(this.formEvento.controls['fechaDead'].value !== 'Invalid date'){
          item.deadline = moment((this.formEvento.controls['fechaDead'].value)).format("YYYY-MM-DD");
        }else{
          item.deadline = null;
        }
        if(this.formEvento.controls['estatusPlan'].value  !== 'default'){
          item.plan_status = Number(this.formEvento.controls['estatusPlan'].value);
        }else{
          item.plan_status = null;
        }

        item.net_loss = item.monto_perdida-item.perdida_trasladada;
        item.x = valIm;
        item.y = valPr;
        item.institution_id = this.idInstitucion;

        try {
          const response = await firstValueFrom(
            this.services.patchEventos(item)
          );
          item.select = false;
          this.selecCategoriaFilter();
          Swal.close();
          this.existSelec = false;
          messages.succesMessageGraph(this.translate.instant('operative.matriz-eventos.informacion-editada'));
        } catch (error) {
          if (error.status === 412) {
            messages.succesMessageGraph(this.translate.instant('operative.matriz-eventos.informacion-editada'));
            item.select = false;
            this.selecCategoriaFilter();
            this.existSelec = false;
            break;
          } else {
            messages.errorMessageGraph(error.error);
          }
        }
      }
    }
    this.cerrar();
  }
  public riesgoImp(){
    if(this.agr || this.edi){
      let imp = this.formEvento.controls['impacto'].value;
      let pro = this.formEvento.controls['probabilidad'].value;

      if(imp !== 'default' && pro !== 'default'){
        const im = this.impacto.filter(item => item.id === Number(imp))[0].name;
        const pr = this.probabilidad.filter(item => item.id === Number(pro))[0].name;

        const valIm = this.impactoVal.filter(item => item.name === im)[0].id;
        const valPr = this.probabilidadVal.filter(item => item.name === pr)[0].id;
        
        let val = valIm*valPr;
        this.formEvento.controls['riesgoImp2'].setValue(''+val);

        for(const item of this.nivelRiesgo){
          if(item.min <= val && val < item.max){
            this.formEvento.controls['riesgoImp'].setValue(item.name);
          }
        }

        let cont = this.formEvento.controls['control'].value;

        if(cont !== ''){
          let ne =  this.formEvento.controls['porACont'].value;
          let valor = (Number(ne)*val)/100;
    
          for(const item of this.nivelExpocision){
            if(item.min <= valor && valor < item.max){
              this.formEvento.controls['nivelExp'].setValue(item.name);
            }
          }
        }
      }
    }
  }
  public controlImp(){
    if(this.agr || this.edi){
      let cont = this.formEvento.controls['control'].value;
    
      if(cont !== 'default'){
        const con = this.control.filter(item => item.id === Number(cont))[0].name;
        const conVal = this.controlVal.filter(item => item.name === con)[0].id;

        this.formEvento.controls['porControl'].setValue(''+conVal);
        this.formEvento.controls['porACont'].setValue(''+(100-conVal));

        let imp = this.formEvento.controls['impacto'].value;
        let pro = this.formEvento.controls['probabilidad'].value;

        if(imp !== 'default' && pro !== 'default'){
          let ne = this.formEvento.controls['riesgoImp2'].value;
          this.nivelExp = ((100-conVal)*Number(ne))/100;

          for(const item of this.nivelExpocision){
            if(item.min <= this.nivelExp && this.nivelExp < item.max){
              this.formEvento.controls['nivelExp'].setValue(item.name);
              
            }
          }
        }
      }
    }
  }
  public selecCategoria(){
    this.formEvento.controls['concepto'].setValue('');
    this.formEvento.controls['evento'].setValue('');
    if(this.edi || this.agr){
      const cat = Number(this.formEvento.controls['categoria'].value);
      const val = this.categorias.filter( c => c.id === cat )[0];
      this.conceptos = [].concat(val.values);
    }
    this.formEvento.controls['concepto'].setValue('default');
    this.formEvento.controls['evento'].setValue('default');
  }
  public selecConcepto(){
    this.formEvento.controls['evento'].setValue('');
    if(this.edi || this.agr){
      if(this.formEvento.controls['concepto'].value!=='' && this.formEvento.controls['concepto'].value!==null && this.niveles>=3){
        const con = Number(this.formEvento.controls['concepto'].value);
        const val2 = this.conceptos.filter( c => c.id === Number(con) )[0];
        this.eventos = [].concat(val2.values);
      }
    }
    this.formEvento.controls['evento'].setValue(null);
  }
  public ingresoMontosForm(){
    const dat = Number(this.formEvento.controls['perdida'].value);
    const sel = this.perdida.filter(p => p.id === dat);
    if(sel[0].name.toLowerCase() === 'no cuantificable'){
      this.formEvento.controls['monto'].setValue('0');
      this.formEvento.controls['perdidaTras'].setValue('0');
      this.ingresoMontos = false;
    }else{
      this.ingresoMontos = true;
    }
  }
  //Validaciones
  private defaultValidation(control): ValidatorFn {
    return (formGroup: FormGroup) => {
      if(this.agr || this.edi){
        const val = this.formEvento.controls[control].value;
        if(val !== 'default' && val !== '' ){
          return null;
        }
      }
      return {isValid:true};
    };
  }
  private montoCorrectoValidacion(): ValidatorFn {
    return (formGroup: FormGroup) => {
      var valMax = 0, val = 0;
      if(this.agr || this.edi){
        valMax = Number(this.formEvento.controls['monto'].value);      
        val = Number(this.formEvento.controls['perdidaTras'].value); 
      }
      if(val>valMax) return {isValid:true};
      return null;
    };
  }
  public montoCorrecto():  boolean  {    
    return  this.formEvento.hasError('isValid');
  }
  public info(){
    var texto = 'Recuerde llenar todas las secciones para guardar un nuevo evento';
    messages.infoMessageGraph(texto);
  }
  /* Botones */
  public borrarFiltro(){
    this.formSelects.controls['area'].setValue('default');
    this.formSelects.controls['agencia'].setValue('default');
    this.formSelects.controls['categoria'].setValue('default');
    
    this.dataOrdenado = [].concat(this.dataOrdenadoAll);
    this.orden('fecha');
  }
  public exportarExcel(){
    var datos = [];

    var encabezados = [ 'Área', 'Agencia/Sucursal', 'Categoría', 'Concepto', 'Evento', 'Fecha Evento', 'Detalle', 'Acción realizada', 'Fuente',
        'Riesgo derivado', 'Pérdida', 'Monto de pérdida', 'Pérdida trasladada', 'Pérdida neta',  'Impacto', 'Probabilidad', 'Control',
        'Nivel de riesgo implícito', 'Recomendación Riesgos', 'Plan de trabajo', 'Fecha (dead line)', 'Estatus del plan', 'Quién registra', 'Estatus del evento'
      ];
    
    for(const i of this.dataOrdenado){
      var aux = [];
      aux.push(this.area.filter(ar => ar.id === i['area'])[0].name);
      aux.push(this.agencia.filter(ar => ar.id === i['branch_office'])[0].name);
      aux.push(this.categorias.filter(ar => ar.id === i['category'])[0].name);
      aux.push(this.categorias.filter(ar => ar.id === i['category'])[0].values.filter(ar => ar.id === i['concept'])[0].name);
      aux.push(this.categorias.filter(ar => ar.id === i['category'])[0].values.filter(ar => ar.id === i['concept'])[0].values.filter(ar => ar.id === i['event'])[0].name);
      aux.push(moment(i['event_date']).format('DD/MM/YYYY'));
      aux.push(i['detail']);
      aux.push(this.accion.filter(ar => ar.id === i['action_taken'])[0].name);
      aux.push(this.fuente.filter(ar => ar.id === i['source'])[0].name);
      aux.push(this.riesgo.filter(ar => ar.id === i['derived_risk'])[0].name);
      aux.push(this.perdida.filter(ar => ar.id === i['loss'])[0].name);
      aux.push(Number(i['loss_amount']));
      aux.push(Number(i['transferred_loss']));
      aux.push(Number(i['net_loss']));
      aux.push(this.impacto.filter(ar => ar.id === i['impact'])[0].name);
      aux.push(this.probabilidad.filter(ar => ar.id === i['probability'])[0].name);
      aux.push(this.control.filter(ar => ar.id === i['control'])[0].name);
      aux.push(this.nivelRiesgo.filter(ar => ar.min <= i['implicit_risk_level'] && i['implicit_risk_level'] < ar.max )[0].name);
      aux.push(i['recommendation']);
      aux.push(i['work_plan']);
      aux.push(moment(i['deadline']).format('DD/MM/YYYY'));
      aux.push(this.estatus.filter(ar => ar.id === i['plan_status'])[0].name);
      aux.push(i['register']);
      aux.push(this.estatusevent.filter(ar => ar.id === i['event_status'])[0].name);

      datos.push(aux);
    }

    let tituloHoja = this.translate.instant('operative.matriz-eventos.tituloPrincipal');
    this.exportExcel.generateEventos(tituloHoja, encabezados, datos, tituloHoja);
  }
  //Estatus del evento
  public validaciones(item, funcion){
    messages.messageSaving(this.translate.instant('operative.matriz-eventos.validando'), this.translate.instant('operative.matriz-eventos.espera'));
    let estatus;
    switch(funcion){
      case 2: estatus = 2; break;
      case 3: estatus = 3; break;
      case 4: estatus = 4; break;
    }

    switch(estatus){
      case 2:
        
        break;
      case 3:
        
        break;
      case 4:

        break;
    }
  }
  /* Filtros */
  public selecCategoriaFilter(){
    let ar = this.formSelects.controls['area'].value;
    let ag = this.formSelects.controls['agencia'].value;
    let ct = this.formSelects.controls['categoria'].value;

    let aux = [];
    if(ar !== 'default'){
      let existentes = [];
      existentes = this.dataOrdenadoAll.filter(rep => Number(rep.area) === Number(ar));
      aux = [].concat(existentes);
    }
    if(ag !== 'default'){
      let existentes = [];
      if(aux.length !== 0 || ar !== 'default'){
        existentes = aux.filter(rep => Number(rep.branch_office) === Number(ag));
      }else{
        existentes = this.dataOrdenadoAll.filter(rep => Number(rep.branch_office) === Number(ag));
      }
      aux = [].concat(existentes);
    }
    if(ct !== 'default'){
      let existentes = [];
      if(aux.length !== 0 || ar !== 'default' || ag !== 'default' ){
        existentes = aux.filter(rep => Number(rep.category) === Number(ct));
      }else{
        existentes = this.dataOrdenadoAll.filter(rep => Number(rep.category) === Number(ct));
      }
      aux = [].concat(existentes);
    }
    if(ar === 'default' && ag === 'default' && ct === 'default'){
      aux = [].concat(this.dataOrdenadoAll);
    }

    if(this.filtroPeriodos){
      let aux2 = [];
      const fechaIni = moment(this.cadenaEvaluacion[0].periodo+'-01');
      const fechaFin = moment(this.cadenaEvaluacion2[0].periodo+'-01');
      for(const dat of aux){
        if(periodosOperativo.validacionPeriodo(moment(dat.event_date),fechaIni,fechaFin)){
          aux2.push(dat);
        }
      }
      aux = [].concat(aux2);
    }

    this.dataOrdenado = [].concat(aux);
    this.orden('fecha');
  }
  public activacionFiltros(){
    this.filtroPeriodos = !this.filtroPeriodos;
    this.selecCategoriaFilter();
  }
}
